(function ($) {

    $(document).ready(function () {


        $('.resources-filter.category li').on("click", function(e) {

            // Prevent default link behavior
            e.preventDefault();

            // Remove 'active' class from all, then add to clicked element
            $('.resources-filter.category li').removeClass('active');
            $(this).addClass('active');

            // Also reset "type" filter if needed
            $('.resources-filter.type li').removeClass('active');
            $('.resources-filter.type li:first-child').addClass('active');

            $('.resources-filter').css('pointer-events', 'none');

            // Get data attributes from clicked element
            var ajaxurl = myajax.url, // or ajaxMeta.ajaxurl
                most_popular_ids  = $(this).data('most_popular_ids') || '',
                editors_picks_ids = $(this).data('editors_picks_ids') || '',
                category          = $(this).data('category') || '',
                pages_add_ids      = $(this).data('pages-add') || '',

                // Cache DOM elements
                resources_filter_type = $('.resources-filter.type'),
                container_all         = $(".block-resources.all"),
                container_popular     = $(".block-resources.most-popular"),
                container_editors     = $(".block-resources.editors-picks"),
                container_add         = $(".additional-posts");

            container_all.find('.items').attr('data-most_popular_ids', most_popular_ids)
                                        .attr('data-editors_picks_ids', editors_picks_ids)
                                        .attr('data-category', category);


            // Make a single AJAX request
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                dataType: 'json', // We expect JSON
                data: {
                    action: 'fetch_all_resources', // Our unified action
                    most_popular_ids: most_popular_ids,
                    editors_picks_ids: editors_picks_ids,
                    category: category,
                    pages_add_ids: pages_add_ids
                },
                success: function(response) {
                    if (!response.success) {
                        console.log('Error: ', response.data);
                        return;
                    }

                    // Extract HTML strings from the JSON response
                    var data = response.data;
                    var popularHtml = data.popular_html;
                    var editorsHtml = data.editors_html;
                    var allHtml     = data.all_html;
                    var addHtml     = data.add_html;

                    // -----------------------------------------
                    // 1) Hide/show "Popular" container
                    // -----------------------------------------
                    if (popularHtml) {
                        container_popular.show();
                        container_popular.find('.items').isotope('destroy').empty().append(popularHtml).find('.item').fadeIn('slow');
                        isotopeInit(container_popular.find('.items')); // re-initialize if needed
                    } else {
                        container_popular.hide();
                        container_popular.find('.items').empty();
                    }

                    // -----------------------------------------
                    // 2) Hide/show "Editors" container
                    // -----------------------------------------
                    if (editorsHtml) {
                        container_editors.show();
                        container_editors.find('.items').isotope('destroy').empty().append(editorsHtml).find('.item').fadeIn('slow');
                        isotopeInit(container_editors.find('.items'));
                    } else {
                        container_editors.hide();
                        container_editors.find('.items').empty();
                    }

                    // -----------------------------------------
                    // 3) Hide/show "All" container
                    // -----------------------------------------
                    if (allHtml) {
                        resources_filter_type.show(); // show the .resources-filter.type
                        container_all.show();
                        container_all.find('.items').isotope('destroy').empty().append(allHtml).find('.item').fadeIn('slow');
                        isotopeInit(container_all.find('.items'));
                    } else {
                        container_all.hide();
                        container_all.find('.items').empty();
                        resources_filter_type.hide();
                    }

                    // -----------------------------------------
                    // 4) Hide/show "Category Add" container
                    // -----------------------------------------
                    if (addHtml) {
                        container_add.show().addClass('active');
                        container_add.find('.items').empty().append(addHtml).find('.item').fadeIn('slow');
                    } else {
                        container_add.hide().removeClass('active');
                        container_add.find('.items').empty();
                    }

                    $('.resources-filter').css('pointer-events', 'auto');
                },
                error: function(err) {
                    console.log('AJAX error: ', err);
                    $('.resources-filter').css('pointer-events', 'auto');
                }
            });

            return false;
        });


        // Handle click events on ".resources-filter.type li"
        $('.resources-filter.type li').on("click", function (e) {
            // Prevent default click behavior
            e.preventDefault();

            // Remove the "active" class from all items, then add it to the clicked one
            $('.resources-filter.type li').removeClass('active');
            $(this).addClass('active');

            $('.resources-filter').css('pointer-events', 'none');

            // Cache references to elements and data
            var ajaxurl = myajax.url,
                $allItems = $(".block-resources.all .items"), // store a reference to avoid repeated lookups
                most_popular_ids = $allItems.data('most_popular_ids'),
                editors_picks_ids = $allItems.data('editors_picks_ids'),
                category = $allItems.data('category'),
                type = $(this).data('type');

            // Perform the AJAX request
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    action: 'fetch_all_resources',
                    most_popular_ids: most_popular_ids,
                    editors_picks_ids: editors_picks_ids,
                    category: category,
                    type: type
                },
                success: function(response) {
                    if (!response.success) {
                        console.log('Error: ', response.data);
                        return;
                    }

                    console.log(response);

                    // Convert the response to a jQuery object
                    var data = response.data;
                    var allHtml = data.all_html;

                    // If the response has content, initialize items with Isotope
                    if (allHtml) {
                        $allItems.isotope('destroy').empty().append(allHtml).find('.item').fadeIn('slow');
                        isotopeInit($allItems);
                    } else {
                        // If empty, display a "Nothing found" message
                        $allItems.isotope('destroy').empty()
                            .append('<p class="nothing-found">Nothing found</p>')
                            .find('.nothing-found').fadeIn('slow');
                    }
                    $('.resources-filter').css('pointer-events', 'auto');
                },
                error: function(err) {
                    console.log('AJAX error: ', err);
                    $('.resources-filter').css('pointer-events', 'auto');
                }
            });

            // Stop further event propagation
            return false;
        });

        $(document).mouseup(function (e) {
            if ($(".video-modal.shown").length) {
                var container = $(".video-modal.shown iframe");

                // If the target of the click isn't the container
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    $(".video-modal.shown").removeClass('shown');
                    var iframe_src = container.attr('src');
                    container.attr('src', iframe_src);
                }
            }
        });

        $('html').on('touchstart', function (e) {
            if ($(".video-modal.shown").length) {
                var container = $(".video-modal.shown iframe");
                $(".video-modal.shown").removeClass('shown');
                var iframe_src = container.attr('src');
                container.attr('src', iframe_src);
            }
        });
        $(".video-modal.shown iframe").on('touchstart', function (e) {
            e.stopPropagation();
        });


        $('.block-resources .items .item').fadeIn();
        isotopeInit($('.block-resources .items'));


        function isotopeInit(block) {
            block.isotope({
                itemSelector: '.item',
                percentPosition: true,
                layoutMode: 'masonry'
            });
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/resources-ajax.es6